import 'unfetch/polyfill';
import Vue from 'vue';
import Basefront from '@holamundo.app/basefront-vue';
import { Layout, Modal, Tabs, Card } from 'bootstrap-vue/es/components';
import lang from 'element-ui/lib/locale/lang/es';
import locale from 'element-ui/lib/locale';
import VueScreenSize from 'vue-screen-size';
import JsonExcel from 'vue-json-excel';


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import '@holamundo.app/basefront-vue/dist/basefront-vue.css';

import App from '@/App';
import router from '@/router';
import store from '@/store';

Vue.config.productionTip = false;

Vue.use(VueScreenSize);
Vue.component('downloadExcel', JsonExcel);
Vue.use(Card);
Vue.use(Layout);
Vue.use(Modal);
Vue.use(Tabs);

Vue.use(Basefront, {
  theme: {
    colors: {
      ...(process.env.VUE_APP_ENV === 'test' ? { primary: '#7db478' } : {}),
      ...(process.env.VUE_APP_ENV === 'prod' ? { primary: '#002687' } : {}),
    },
  },
});

// configure element-ui language
locale.use(lang);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
